export default __webpack_public_path__ + "static/media/logo-min.ad38bf63.svg";